var React = require('react');

function CheckOn (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_275_14350)","key":0},[React.createElement("rect",{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"1.5","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M3 8L6 11L13 4","stroke":"currentColor","strokeWidth":"2","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_275_14350"},React.createElement("rect",{"width":"16","height":"16","fill":"currentColor"})))]);
}

CheckOn.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckOn;

CheckOn.default = CheckOn;
